import React from 'react';
import Checkbox from '../../components/checkbox/checkbox';
import { EndOfWeekDay } from '@bringg/types';
import { arrayService } from '../../services/array-service';
import styles from './days-in-week.module.scss';

interface DaysTranslates {
	su: string;
	mo: string;
	tu: string;
	we: string;
	th: string;
	fr: string;
	sa: string;
}
interface Props {
	endOfWeekDay: EndOfWeekDay;
	translates: DaysTranslates;
	value: EndOfWeekDay[];
	onChange: (weekDays: number[]) => void;
}

const endOfWeekToRotationNumber: Record<EndOfWeekDay, number> = {
	[EndOfWeekDay.Sunday]: 1,
	[EndOfWeekDay.Monday]: 2,
	[EndOfWeekDay.Tuesday]: 3,
	[EndOfWeekDay.Wednesday]: 4,
	[EndOfWeekDay.Thursday]: 5,
	[EndOfWeekDay.Friday]: 6,
	[EndOfWeekDay.Saturday]: 0
};

const getOptions = (translates, lastDayInWeek: EndOfWeekDay) => {
	const week = arrayService.rotateArray(
		[
			{ label: translates.su, value: EndOfWeekDay.Sunday },
			{ label: translates.mo, value: EndOfWeekDay.Monday },
			{ label: translates.tu, value: EndOfWeekDay.Tuesday },
			{ label: translates.we, value: EndOfWeekDay.Wednesday },
			{ label: translates.th, value: EndOfWeekDay.Thursday },
			{ label: translates.fr, value: EndOfWeekDay.Friday },
			{ label: translates.sa, value: EndOfWeekDay.Saturday }
		],
		endOfWeekToRotationNumber[lastDayInWeek] || 0
	);

	return week;
};

const DaysInWeek = ({ endOfWeekDay, translates, value, onChange }: Props) => {
	return (
		<Checkbox.Group
			className={styles.daysInWeek}
			options={getOptions(translates, endOfWeekDay)}
			value={value}
			onChange={weekDays => onChange(weekDays as number[])}
		/>
	);
};

export default DaysInWeek;
